import React from 'react'

import { Stack } from '@mui/material'

import useTrans from '@/hooks/useTrans'

import MenuLink from '@/layouts/components/MenuLink'

const MainMenuItems = () => {
  const trans = useTrans()

  return (
    <>
      <Stack>
        <MenuLink href="/" data-testid="header-trade">
          {trans.header.trade}
        </MenuLink>
      </Stack>
      <Stack>
        <MenuLink
          href="/assets"
          data-testid="header-assets"
          activeHref="/assets">
          {trans.header.assets}
        </MenuLink>
      </Stack>
      <Stack>
        <MenuLink
          href="/liquidity/browse"
          activeHref="/liquidity"
          data-testid="header-nav-liquidity"
        >
          {trans.header.liquidity}
        </MenuLink>
      </Stack>
    </>
  )
}

export default MainMenuItems
